const galleries = document.querySelectorAll('.wp-block-gallery');

galleries.forEach(gallery => {
  let links = gallery.querySelectorAll('a');

  links.forEach(link => {
    link.setAttribute('data-fslightbox', 'gallery');
  });
});

refreshFsLightbox();